"use client";

import { type CSSProperties, type MouseEvent } from "react";

import ResponsiveDialog from "@/features/ResponsiveDialog/ResponsiveDialog";
import DialogCloseBtn from "@/features/ResponsiveDialog/styled/DialogCloseBtn";
import { themeColors } from "@/utils/themeColors";
import { spacing } from "@/utils/spacing";
import { FlexColumn } from "@/components/Flex";
import LinkWrapper from "@/components/wrappers/Link";
import VimeoVideo from "@/components/VimeoVideo";
import Mixpanel from "@/utils/analytics/Mixpanel";

type Props = {
    isOpen: boolean;
    onClose: (e: MouseEvent) => void;
};

export const RateExtensionPopup = ({ isOpen, onClose }: Props) => {
    return (
        <ResponsiveDialog
            isOpen={isOpen}
            onClose={onClose}
            style={{ backgroundColor: themeColors.neutralWhite, overflow: "hidden" }}
            DialogProps={{
                classes: {
                    paper: "scrollbar",
                },
            }}
            DialogStyle={{
                padding: spacing.MD,
                width: "62.9rem",
                height: "auto",
                borderRadius: "4rem",
                overflowY: "scroll",
            }}
            SlideMenuStyle={{
                padding: "2.5rem 2rem 1rem",
            }}>
            <div data-testid="auto-id-f86bf5d1-4090-49ab-9d93-4377d2b68b50">
                <DialogCloseBtn onClick={onClose} style={{ marginLeft: "auto", marginBottom: "2rem" }} />
                <FlexColumn style={{ gap: "2rem", alignItems: "center" }}>
                    <VimeoVideo id="1024591633" style={{ height: "32rem" }} iframeStyle={{ borderRadius: "3rem" }} />
                    <h4
                        className="heading4"
                        style={{
                            fontWeight: "700",
                        }}
                        data-testid="auto-id-826e1627-74b8-478e-a2e2-0b40aefa4560">
                        Rate our Chrome Extension 5 Stars!
                    </h4>
                    <p
                        className="bodyBold1"
                        style={{ maxWidth: "41rem", fontWeight: "500", textAlign: "center" }}
                        data-testid="auto-id-00cc35dc-6662-4355-a522-d78510dc2076">
                        Could you pretty please take a moment to give us 5 stars? It would really make our day!
                    </p>
                    <LinkWrapper
                        className="link"
                        openInNewTab
                        onClick={e => {
                            Mixpanel.track("Chrome Extension Rating Popup - Clicked");
                            onClose(e);
                        }}
                        href="https://chromewebstore.google.com/detail/knowt-quizlet-import-ai-n/akegecpdcdbkjioddaingaedacjgfjhm"
                        style={
                            {
                                backgroundColor: themeColors.primary,
                                paddingInline: "3.2rem",
                                paddingBlock: "1.2rem",
                                borderRadius: "4rem",
                                fontSize: "1.8rem",
                                lineHeight: "2.8rem",
                                fontWeight: "700",
                                "--link-color": themeColors.primaryDark,
                                "--link-hover-color": themeColors.pureBlack,
                            } as CSSProperties
                        }>
                        Rate it!
                    </LinkWrapper>
                </FlexColumn>
            </div>
        </ResponsiveDialog>
    );
};
